import { ComponentType, IConfig } from '../../types';
import {
  BASIC_JSON_LOGIC_TOOLTIP,
  BASIC_SWITCH_VALUE_TOOLTIP,
  BASIC_VALUE_TOOLTIP,
  BASIC_VARIABLE_TOOLTIP,
  ComponentConfigType,
} from '../../utils';

const INPUT_TOOLTIPS = [
  { key: ComponentConfigType.Variable, value: BASIC_VARIABLE_TOOLTIP },
  { key: ComponentConfigType.Value, value: BASIC_VALUE_TOOLTIP },
  { key: ComponentConfigType.JsonLogic, value: BASIC_JSON_LOGIC_TOOLTIP },
];

const SWITCH_TOOLTIPS = [
  { key: ComponentConfigType.Variable, value: BASIC_VARIABLE_TOOLTIP },
  { key: ComponentConfigType.Value, value: BASIC_SWITCH_VALUE_TOOLTIP },
  { key: ComponentConfigType.JsonLogic, value: BASIC_JSON_LOGIC_TOOLTIP },
];

export const config: IConfig = {
  component: ComponentType.FilePanel,
  configGroups: [
    {
      title: 'Component Properties',
      items: [
        {
          name: 'file',
          label: 'File',
          valueComponent: { type: 'Input' },
          configTypes: [
            ComponentConfigType.Variable,
            ComponentConfigType.JsonLogic,
          ],
          tooltips: INPUT_TOOLTIPS,
        },
        {
          name: 'modelInstanceId',
          label: 'Model Instance ID',
          valueComponent: { type: 'Input' },
          configTypes: [
            ComponentConfigType.Variable,
            ComponentConfigType.Value,
            ComponentConfigType.JsonLogic,
          ],
          tooltips: INPUT_TOOLTIPS,
        },
        {
          name: 'visible',
          label: 'Visible',
          valueComponent: { type: 'Switch' },
          configTypes: [
            ComponentConfigType.Variable,
            ComponentConfigType.Value,
            ComponentConfigType.JsonLogic,
          ],
          tooltips: SWITCH_TOOLTIPS,
        },
        {
          name: 'downloadButtonText',
          label: 'Download Button Text',
          valueComponent: { type: 'Input' },
          configTypes: [
            ComponentConfigType.Variable,
            ComponentConfigType.Value,
            ComponentConfigType.JsonLogic,
            ComponentConfigType.Translate,
          ],
          tooltips: INPUT_TOOLTIPS,
        },
        {
          name: 'previewButtonNotAvailableText',
          label: 'Preview Not Available Text',
          valueComponent: { type: 'Input' },
          configTypes: [
            ComponentConfigType.Variable,
            ComponentConfigType.Value,
            ComponentConfigType.JsonLogic,
            ComponentConfigType.Translate,
          ],
          tooltips: INPUT_TOOLTIPS,
        },
      ],
    },
    {
      title: 'Component Styles',
      component: 'CssSettings',
    },
  ],
};
